import _ from 'lodash'
import {listToMap, parseItem} from '@/utils/media'
import {IDataSource} from '.'

export function gfpItemSource<T extends {catalog: string; vionlabsID: string}>(
  args: T
): IDataSource<T> {
  const {catalog, vionlabsID} = args

  return {
    sourceID: 'gfpItem',
    key: vionlabsID,
    args,
    fetch: async () => {
      const response = await fetch(
        `/api/gfp-result/items/${encodeURIComponent(vionlabsID)}?catalog=${encodeURIComponent(catalog)}`
      )
      if (!response.ok) throw new Error('failed to fetch gfp item')
      const responseData = await response.json()
      if (!responseData) throw new Error('failed to read gfp item data')
      return listToMap([parseItem(responseData)])
    },
  }
}
